module.exports = __webpack_public_path__ + "static/media/bff14.3476831c.png";